<template>
  <BaseView class="index-container">
    <div slot="contantView" class="content">
      <div class="index-panel">
        <div class="nav-panel">
          <HeaderView :active-index="2" />
          <img src="../assets/spsc/services/navBg.png" class="navImg"/>
        </div>
        <section class="nav-section">
          <div class="nav-info">
            <div class="nav-main-text" @click="goGoalPage('/')">Home</div>
            <div class="nav-arrow">></div>
            <div class="nav-sub-text" @click="goGoalPage('/services')">Service&Projects</div>
          </div>
          <div class="nav-line"></div>
        </section>
        <section class="content-panel">
          <div class="services-group">
            <div class="main-text">SERVICE</div>
            <div class="content-line"></div>
            <div class="intro-text">
              <span>To build the bridge between Made In China and the global market, we SinoPacific Supply Chain Co., Ltd can provide lower pricing, massive variety of </span>
              <span>commodities and advantageous delivery times to meet your project needs. But most of all, we ensure quality and safety requirements are met by all parties concerned.</span>
            </div>
            <div class="services-info">
              <div class="left-services">
                <div class="services-name">Heavy steel fabrication</div>
                <div class="services-name">Sheet piles</div>
                <div class="services-name">Steel work for transmission towers</div>
                <div class="services-name">Accommodation&office modules</div>
                <div class="services-name">Drill pipe</div>
                <div class="services-name">Offshore crane</div>
                <div class="services-name">Precast segment</div>
              </div>
              <div class="right-services">
                <div class="services-name">Light steel fabrication</div>
                <div class="services-name">Steel piles</div>
                <div class="services-name">Steel work for wind farm tower</div>
                <div class="services-name">Container</div>
                <div class="services-name">Gantry cranes</div>
                <div class="services-name">Cable tray</div>
                <div class="services-name">Pre-cast concrete panels</div>
              </div>  
            </div>
          </div>
          <div class="projects-group">
            <div class="main-text">PROJECTS</div>
            <div class="content-line"></div>
            <div class="intro-text">
              <span>SPSC team has successfully delivered hundreds of high quality projects with 50 suppliers to more than 40 countries and regions.</span>
            </div>
            <div class="projects-info">
              <div class="project-item" v-for="(item, index) in projects" :key="item.id" @click="goProjectsPage(item)">
                <div class="project-pic">
                  <img :src="item.imgUrl" class="project-img" />
                </div>
                <div class="project-name">{{ item.name }}</div>
                <div class="project-intro">
                  <div class="intro-item" v-for="introItem in item.introArr" :key="introItem.id">
                    <div class="intro-name">{{introItem.text}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterView />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from '@/components/BaseView.vue'
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'

export default {
  name: '',
  props: {

  },
  components: {
    BaseView,
    HeaderView,
    FooterView
  },
  data () {
    return {
      projects:[{
        id: 1,
        imgUrl: require('../assets/spsc/services/project1.png'),
        name: 'Civic Building',
        introArr: [{
          id: 11,
          text: 'Aluminum alloy bridge'
        }, {
          id: 12,
          text: 'Steel bridge'
        }, {
          id: 13,
          text: 'Formworks'
        }, {
          id: 14,
          text: 'Tunnel construction Facilities'
        }, {
          id: 15,
          text: 'Concrete'
        }]
      }, {
        id: 2,
        imgUrl: require('../assets/spsc/services/project2.png'),
        name: 'Wharf Engineering Facilities',
        introArr: [{
          id: 21,
          text: 'Marine steel facilities'
        }, {
          id: 22,
          text: 'Marine fenders panels'
        }, {
          id: 23,
          text: 'piles caps'
        }, {
          id: 24,
          text: 'Other marine equipment'
        }]
      }, {
        id: 3,
        imgUrl: require('../assets/spsc/services/project3.png'),
        name: 'Mining Equipment&Facilities',
        introArr: [{
          id: 31,
          text: 'Copper Mine Equipment'
        }, {
          id: 32,
          text: 'Salt Mine Equipment'
        }, {
          id: 33,
          text: 'Iron Mine Equipment'
        }, {
          id: 34,
          text: 'Lithium Mine Equipment'
        }, {
          id: 35,
          text: 'Roller'
        }]
      }, {
        id: 4,
        imgUrl: require('../assets/spsc/services/project4.png'),
        name: 'Metal Fabrication And Machining Product',
        introArr: [{
          id: 41,
          text: 'Steel products'
        }, {
          id: 42,
          text: 'Aluminium product'
        }, {
          id: 43,
          text: 'Stainless steel products'
        }]
      }, {
        id: 5,
        imgUrl: require('../assets/spsc/services/project5.png'),
        name: 'Piles',
        introArr: [{
          id: 51,
          text: 'Water pile'
        }, {
          id: 52,
          text: 'Steel Seamless pile'
        }, {
          id: 53,
          text: 'Welded pile'
        }]
      }, {
        id: 6,
        imgUrl: require('../assets/spsc/services/project6.png'),
        name: 'New Energy',
        introArr: [{
          id: 61,
          text: 'Solar photovoltaic panels'
        }, {
          id: 62,
          text: 'Wind power tower'
        }]
      }, {
        id: 7,
        imgUrl: require('../assets/spsc/services/project7.png'),
        name: 'Vessel And Tank',
        introArr: [{
          id: 71,
          text: 'LNG tank'
        }, {
          id: 72,
          text: 'Chimney equipment'
        }]
      }, {
        id: 8,
        imgUrl: require('../assets/spsc/services/project8.png'),
        name: 'Hosting Equipment',
        introArr: [{
          id: 81,
          text: 'Kling crane'
        }, {
          id: 82,
          text: 'Gantry crane'
        }, {
          id: 83,
          text: 'Offshore crane'
        }]
      }, {
        id: 9,
        imgUrl: require('../assets/spsc/services/project9.png'),
        name: 'Steel Tower',
        introArr: [{
          id: 91,
          text: 'Electric transmission line tower'
        }, {
          id: 92,
          text: 'Communication steel tower '
        }]
      }, {
        id: 10,
        imgUrl: require('../assets/spsc/services/project10.png'),
        name: 'Trading Service',
        introArr: [{
          id: 101,
          text: 'Casting'
        }, {
          id: 102,
          text: 'Stainless fastener'
        }, {
          id: 103,
          text: 'Other'
        }]
      }]
    }
  },
  methods: {
    goProjectsPage(item) {
      console.log('======item', item)
      this.$router.replace({ path: '/projects', query: {projectIndex: item.id} })
    },
    goGoalPage( pathName) {
      this.$router.replace({ path: pathName})
    }
  },
  created () {
  }
}
</script>
<style scoped lang="scss">

.index-container {
  background: #FFFFFF;
  width: 100%;
}
.index-panel {
  width: 100%;
  min-width: 1200px;
} 

.nav-panel {
  width: 100%;
  height: 100%;
}

.navImg {
  width: 100%;
  height: auto;
  margin-top: -80px;
}

.nav-section {
  width: 1200px;
  margin: 40px auto 60px auto;
}

.nav-info {
  display: flex;
  justify-content: flex-start;
  justify-items: center;
}

.nav-main-text, .nav-sub-text {
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.nav-arrow {
  margin: 0 10px;
}

.nav-line {
  width: 100%;
  height: 1px;
  background: #D8D8D8;
  margin-top: 16px;
}

.content-panel {
  width: 1200px;
  margin: 0 auto 80px auto;
}

.main-text {
  font-size: 32px;
  font-weight: bold;
  color: #111111;
}

.content-line {
  width: 100%;
  height: 4px;
  background: #0281C1;
  margin: 20px auto 40px auto;
}

.intro-text {
  font-size: 16px;
  color: #333333;
  line-height: 28px;
}

.services-info {
  display: flex;
  margin-top: 30px;
  margin-bottom: 100px;
}

.left-services {
  width: 380px;
  margin-right: 120px;
}

.services-name {
  font-size: 20px;
  color: #333333;
  line-height: 28px;
  margin-bottom: 16px;
}

.projects-info {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 48px;
}

.project-item {
  width: 380px;
  height: 480px;
  background: #F6F6F6;
  margin-bottom: 40px;
  cursor: pointer;
}

.project-pic {
  width: 380px;
  height: 280px;
  overflow: hidden;
}

.project-img {
  width: 380px;
  height: 280px; 
  cursor: pointer;  
  transition: all 0.6s;   
}

.project-pic img:hover {
  transform: scale(1.3);
}

.project-name {
  font-size: 24px;
  font-weight: bold;
  color: #111111;
  line-height: 24px;
  margin-top: 16px;
  margin-left: 28px;
}

.project-intro {
  margin: 10px 0 0 28px;
}

.intro-name {
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  margin-bottom: 4px;
}

</style>